// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.padding {\n  padding: 30px;\n}\n.switch_tab {\n  text-align: center;\n  opacity: 0.5;\n  font-size: 14px;\n  margin: 10px;\n  cursor: pointer;\n}\n.changeBtn {\n  float: right;\n  line-height: 30px;\n  opacity: 0.5;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
